export default "__VITE_ASSET__C6pYAn5w__"